import React, { useEffect, useState, useRef, useCallback } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { walldata } from '../Config/wallcoveringminimalandpatterndata';
import WallCards from "../Components/wallcoveringminimalpatternCards";
import OurInformation from '../Components/OurInformation';
import AddToWishlistButton from "../Components/AddToWishlistButton";

// Component for Mobile View
const WallcoveringsMinimalPatternMobile = ({ visibleItems, lastCardRef, cardRefs }) => {
  return (
    <div className="overflow-hidden px-2 sm:px-5">
      <div className='services__area pt-10 hidden sm:block' id='services'>
      </div>

      <div className='grid grid-cols-2 gap-2 max-[640px]:grid-cols-2 max-[640px]:px-0 justify-items-center'>
        {walldata.slice(0, visibleItems).map((it, index) => (
          <div
            className="w-full max-[640px]:px-1 relative"
            key={index}
            ref={(el) => {
              if (el) cardRefs.current[index] = el;
            }}
          >
            <Link to={`/wallcoverings/minimal and pattern/desc/${index + 1}`}>
              <WallCards
                ImgSrc={it.Img}
                ImgJpg={it.ImgJpg}
                title={it.title}
                btn={it.btn}
                isDesktop={false}
                item={it}
                showWishlistButton={false}
              />
            </Link>
            <div className="absolute top-2 right-2 z-20" onClick={(e) => { e.stopPropagation(); e.preventDefault(); }}>
              <AddToWishlistButton 
                item={it}
                size="small"
              />
            </div>
          </div>
        ))}
      </div>
      {/* Invisible div that the IntersectionObserver will watch */}
      {visibleItems < walldata.length && <div ref={lastCardRef} className="h-1" />}
    </div>
  );
};

// Component for Tablet View
const WallcoveringsMinimalPatternTablet = ({ visibleItems, lastCardRef, cardRefs }) => {
  return (
    <div className="overflow-hidden px-3 pt-10">
      <div className='services__area hidden sm:block' id='services'>
      </div>

      <div className='grid grid-cols-2 gap-3 justify-items-center'>
        {walldata.slice(0, visibleItems).map((it, index) => (
          <div
            className="w-full max-w-[160px] relative"
            key={index}
            ref={(el) => {
              if (el) cardRefs.current[index] = el;
            }}
          >
            <Link to={`/wallcoverings/minimal and pattern/desc/${index + 1}`}>
              <WallCards
                ImgSrc={it.Img}
                ImgJpg={it.ImgJpg}
                title={it.title}
                btn={it.btn}
                isDesktop={false}
                item={it}
                showWishlistButton={false}
              />
            </Link>
            <div className="absolute top-2 right-2 z-20" onClick={(e) => { e.stopPropagation(); e.preventDefault(); }}>
              <AddToWishlistButton 
                item={it}
                size="small"
              />
            </div>
          </div>
        ))}
      </div>
      {/* Invisible div that the IntersectionObserver will watch */}
      {visibleItems < walldata.length && <div ref={lastCardRef} className="h-1" />}
    </div>
  );
};

// Component for Mid-Desktop View
const WallcoveringsMinimalPatternMidDesktop = ({ visibleItems, lastCardRef, cardRefs }) => {
  return (
    <div className="overflow-hidden px-4 pt-14">
      <div className='services__area hidden sm:block' id='services'>
      </div>

      <div className='grid grid-cols-3 gap-4 justify-items-center'>
        {walldata.slice(0, visibleItems).map((it, index) => (
          <div
            className="w-full max-w-[260px] relative"
            key={index}
            ref={(el) => {
              if (el) cardRefs.current[index] = el;
            }}
          >
            <Link to={`/wallcoverings/minimal and pattern/desc/${index + 1}`}>
              <WallCards
                ImgSrc={it.Img}
                ImgJpg={it.ImgJpg}
                title={it.title}
                btn={it.btn}
                isDesktop={false}
                customStyle="w-full h-[180px] object-cover scale-105"
                item={it}
                showWishlistButton={false}
              />
            </Link>
            <div className="absolute top-2 right-2 z-20" onClick={(e) => { e.stopPropagation(); e.preventDefault(); }}>
              <AddToWishlistButton 
                item={it}
                size="small"
              />
            </div>
          </div>
        ))}
      </div>
      {/* Invisible div that the IntersectionObserver will watch */}
      {visibleItems < walldata.length && <div ref={lastCardRef} className="h-1" />}
    </div>
  );
};

// Component for Laptop View
const WallcoveringsMinimalPatternLaptop = ({ visibleItems, lastCardRef, cardRefs }) => {
  return (
    <div className="overflow-hidden p-0 sm:p-5 pt-20">
      <div className='services__area pt-10 hidden sm:block' id='services'>
      </div>

      <div className='grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 gap-6 justify-items-center max-w-[1400px] mx-auto px-4'>
        {walldata.slice(0, visibleItems).map((it, index) => (
          <div
            className="w-full sm:w-auto relative"
            key={index}
            ref={(el) => {
              if (el) cardRefs.current[index] = el;
            }}
          >
            <Link to={`/wallcoverings/minimal and pattern/desc/${index + 1}`}>
              <WallCards
                ImgSrc={it.Img}
                ImgJpg={it.ImgJpg}
                title={it.title}
                btn={it.btn}
                isDesktop={true}
                item={it}
                showWishlistButton={false}
              />
            </Link>
            <div className="absolute top-2 right-2 z-20" onClick={(e) => { e.stopPropagation(); e.preventDefault(); }}>
              <AddToWishlistButton 
                item={it}
                size="small"
              />
            </div>
          </div>
        ))}
      </div>
      {/* Invisible div that the IntersectionObserver will watch */}
      {visibleItems < walldata.length && <div ref={lastCardRef} className="h-1" />}
    </div>
  );
};

const WallcoveringMinimalPattern = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const scrollToId = searchParams.get('scrollTo');
  
  console.log('[WallcoveringMinimalPattern] Component rendered - scrollToId from URL:', scrollToId, 'Full URL:', location.pathname + location.search);
  
  // Always prioritize sessionStorage over URL parameter
  useEffect(() => {
    const currentScrollToId = new URLSearchParams(location.search).get('scrollTo');
    const lastViewedId = sessionStorage.getItem('lastViewedImageIdWallcoveringminimalpattern');
    
    console.log('[WallcoveringMinimalPattern] Checking - scrollToId in URL:', currentScrollToId, 'lastViewedId in storage:', lastViewedId);
    
    if (lastViewedId) {
      if (currentScrollToId !== lastViewedId) {
        console.log('[WallcoveringMinimalPattern] sessionStorage has different value than URL. Updating URL to use latest:', lastViewedId);
        const newSearchParams = new URLSearchParams(location.search);
        newSearchParams.set('scrollTo', lastViewedId);
        navigate(`${location.pathname}?${newSearchParams.toString()}`, { replace: true });
        sessionStorage.removeItem('lastViewedImageIdWallcoveringminimalpattern');
      } else {
        sessionStorage.removeItem('lastViewedImageIdWallcoveringminimalpattern');
      }
    }
  }, [location.pathname, location.search, navigate]);
  
  // State to manage the number of visible items, starting with 20.
  const [visibleItems, setVisibleItems] = useState(20);
  const [screenType, setScreenType] = useState('mobile');
  const [hasScrolledToTarget, setHasScrolledToTarget] = useState(false);

  // Reset scroll state when scrollToId changes
  useEffect(() => {
    const currentScrollToId = new URLSearchParams(location.search).get('scrollTo');
    if (currentScrollToId) {
      setHasScrolledToTarget(false);
    }
  }, [location.search]);

  const observer = useRef();
  const cardRefs = useRef({});
  
  const lastCardRef = useCallback(node => {
    if (observer.current) {
      observer.current.disconnect();
    }
    
    observer.current = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting && visibleItems < walldata.length) {
        setVisibleItems(prevItems => Math.min(prevItems + 20, walldata.length));
      }
    }, {
      rootMargin: '400px 0px',
    });

    if (node) {
      observer.current.observe(node);
    }
  }, [visibleItems]);

  // Handle scrolling to target image - direct scroll without transition
  useEffect(() => {
    const currentScrollToId = new URLSearchParams(location.search).get('scrollTo');
    
    if (currentScrollToId && !hasScrolledToTarget) {
      const targetIndex = parseInt(currentScrollToId) - 1;
      
      if (targetIndex >= visibleItems) {
        const newVisibleItems = Math.max(visibleItems, targetIndex + 10);
        setVisibleItems(newVisibleItems);
        return;
      }
      
      const attemptScroll = (attempt = 1) => {
        const targetElement = cardRefs.current[targetIndex];
        
        if (targetElement) {
          targetElement.scrollIntoView({
            behavior: 'auto',
            block: 'center'
          });
          setHasScrolledToTarget(true);
          return true;
        }
        return false;
      };

      const timer1 = setTimeout(() => {
        if (!attemptScroll(1)) {
          setTimeout(() => {
            if (!attemptScroll(2)) {
              setTimeout(() => {
                if (!attemptScroll(3)) {
                  setTimeout(() => {
                    attemptScroll(4);
                  }, 200);
                }
              }, 200);
            }
          }, 200);
        }
      }, 200);
      
      return () => {
        clearTimeout(timer1);
      };
    }
  }, [location.search, hasScrolledToTarget, visibleItems]);

  useEffect(() => {
    const updateScreenType = () => {
      const width = window.innerWidth;
      if (width <= 635) {
        setScreenType('mobile');
      } else if (width >= 636 && width <= 788) {
        setScreenType('tablet');
      } else if (width >= 800 && width <= 1244) {
        setScreenType('mid-desktop');
      } else {
        setScreenType('laptop');
      }
    };

    updateScreenType();
    window.addEventListener('resize', updateScreenType);
    return () => window.removeEventListener('resize', updateScreenType);
  }, []);

  const renderScreenComponent = () => {
    if (screenType === 'tablet') {
      return <WallcoveringsMinimalPatternTablet visibleItems={visibleItems} lastCardRef={lastCardRef} cardRefs={cardRefs} />;
    }
    if (screenType === 'mid-desktop') {
      return <WallcoveringsMinimalPatternMidDesktop visibleItems={visibleItems} lastCardRef={lastCardRef} cardRefs={cardRefs} />;
    }
    if (screenType === 'laptop') {
      return <WallcoveringsMinimalPatternLaptop visibleItems={visibleItems} lastCardRef={lastCardRef} cardRefs={cardRefs} />;
    }
    return <WallcoveringsMinimalPatternMobile visibleItems={visibleItems} lastCardRef={lastCardRef} cardRefs={cardRefs} />;
  };

  return (
    <div className="min-h-screen bg-gray-50 font-sans">
      {renderScreenComponent()}

      {visibleItems >= walldata.length && (
        <div className="text-center text-gray-500 py-8">
          You've reached the end of the collection!
        </div>
      )}

      <OurInformation />
    </div>
  );
};

export default WallcoveringMinimalPattern;
